
export class UserCompany {
    public name!: string;
    public desc!: string;
    public code!: string;
}
